module.exports = __webpack_public_path__ + "img/car.20cdc7f4.png";